
import { FormState, FormAction } from '../types';
import { supabase } from '../../../integrations/supabase/client';
import { processFileUploads } from './fileHandling';
import { updateUserProfile } from './userProfile';
import { prepareFormDataForSubmission } from './formDataPreparation';

// Submit form data to Supabase
export const submitFormData = async (
  state: FormState, 
  dispatch: React.Dispatch<FormAction>,
  toast: any,
  isAdmin: boolean = false
) => {
  dispatch({ type: 'SUBMIT_START' });

  try {
    // Process file uploads for check_in_photo_urls
    let checkInPhotoUrls: string[] = [];
    try {
      checkInPhotoUrls = await processFileUploads(
        state.formData.check_in_photo_urls as File[],
        'check-in-photos',
        toast,
        5 * 1024 * 1024 // 50MB
      );
    } catch (error) {
      dispatch({ type: 'SUBMIT_ERROR' });
      return;
    }
    
    // Process file uploads for worksheet_urls
    let worksheetUrls: string[] = [];
    try {
      worksheetUrls = await processFileUploads(
        state.formData.worksheet_urls as File[],
        'worksheets',
        toast,
        50 * 1024 * 1024
      );
    } catch (error) {
      dispatch({ type: 'SUBMIT_ERROR' });
      return;
    }
    
    // Prepare the data for submission
    const formDataToSubmit = prepareFormDataForSubmission(
      state.formData, 
      checkInPhotoUrls, 
      worksheetUrls,
      isAdmin
    );

    // Insert data into Supabase
    const { error } = await supabase
      .from('student_development_reports')
      .insert(formDataToSubmit);

    if (error) {
      console.error('Error submitting form to Supabase:', error);
      toast({
        title: 'เกิดข้อผิดพลาด',
        description: 'ไม่สามารถบันทึกข้อมูลได้ กรุณาลองอีกครั้ง',
        variant: 'destructive',
      });
      throw error;
    }
    
    // Update the user's profile with the teacher_id and teacher_display
    const teacherId = state.formData.teacher_id as string;
    const teacherDisplay = state.formData.teacher_id_name_display as string;
    const submitterEmail = state.formData.submitter_email as string;
    
    if (teacherId && submitterEmail) {
      await updateUserProfile(submitterEmail, teacherId, teacherDisplay, toast);
    }
    
    console.log('Form submitted successfully to Supabase!');
    toast({
      title: 'ส่งแบบฟอร์มสำเร็จ',
      description: 'ข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว',
    });
    
    dispatch({ type: 'SUBMIT_SUCCESS' });
    
    // localStorage will be cleared in the useEffect when isSubmitted becomes true
  } catch (error) {
    console.error('Error submitting form:', error);
    toast({
      title: 'เกิดข้อผิดพลาด',
      description: 'ไม่สามารถส่งแบบฟอร์มได้ กรุณาลองอีกครั้ง',
      variant: 'destructive',
    });
    dispatch({ type: 'SUBMIT_ERROR' });
  }
};
